<template>
  <van-nav-bar
    title="作业类别"
    left-text="返回"
    right-text="添加"
    left-arrow
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
  <van-list v-model:loading="loading" :finished="finished">

    <van-cell
        v-for="item in list"
        :key="item.id"
        :title="item.name"
    >
      <template #right-icon>
        <van-button icon="edit" text="编辑" size="mini"
                    plain type="success" @click="clickEvent(item)">
        </van-button>
        <b style="width: 20px">|</b>
      </template>
      <template #extra>
        <van-button icon="arrow" size="mini" type="primary" plain
                    :to="{ path: '/addTrainCourse', query: { parent: item.id } }"
        >
          准操项目
        </van-button>
      </template>
    </van-cell>

<!--    <van-cell
      is-link
      clickable
      :to="{ path: '/addTrainCourse', query: { parent: item.id } }"
      v-for="item in list"
      :key="item.id"
      :title="item.name"
    />-->
  </van-list>

  <van-dialog
    @confirm="addSpeciesId"
    v-model:show="show"
    title="添加作业类别"
    show-cancel-button
  >
    <van-cell-group>
      <van-field
        v-model="ProjectName"
        label="作业类别名称"
        placeholder="请输入作业类别名称"
      />
    </van-cell-group>
  </van-dialog>

  <van-dialog
      @confirm="editTrainProject"
      v-model:show="showEdit"
      title="修改作业类别"
      show-cancel-button
  >
    <template #title>
      <div style="display: flex;flex-direction: column;width: 100%;align-items: center;justify-content: center">
        <b>修改作业类别</b>
        <van-button size="mini" icon="delete" plain type="danger" @click="deleteTrainProject"
                    text="点击删除作业类别"></van-button>
      </div>

    </template>
    <van-cell-group>
      <van-field
          v-model="nowSelectTrainProject.name"
          label="作业类别名称"
          placeholder="请输入作业类别名称"
      />
      <!--      <van-field v-model="money" type="digit" label="培训费用" />-->
    </van-cell-group>
  </van-dialog>

</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { onMounted, reactive, ref, toRefs } from "vue";
import {Dialog, Notify} from "vant";
import axios from "../../api/http";
export default {
  name: "AddTrainProject",
  setup() {
    const router = useRouter();
    const show = ref(false);
    const ProjectName = ref("");
    const route = useRoute();
    console.log(route.query.parent);
    function onClickLeft() {
      router.back();
    }

    const listDemo = reactive({
      list: [],
      loading: false,
      finished: false
    });

    function onClickRight() {
      show.value = true;
    }
    const getAllSpeciesId = () => {
      axios
        .get("/api/RegisterInfo/GetTrainProject/id/" + route.query.parent)
        .then(res => {
          console.log(res.data);
          listDemo.finished = true;
          listDemo.list = res.data;
        });
    };

    function addSpeciesId() {
      console.log(ProjectName.value);
      if (ProjectName.value == "" || ProjectName.value == undefined) {
        Notify({ type: "danger", message: "作业类别名称不可为空" });
        return;
      }
      axios
        .post(
          "/api/addTrainInformation/addTrainProject/" +
            ProjectName.value +
            "/parent/" +
            route.query.parent
        )
        .then(res => {
          console.log(res.data);
          ProjectName.value = "";
          getAllSpeciesId();
        });
    }

    const showEdit = ref(false)
    let nowSelectTrainProject = ref({
      id: undefined,
      name: undefined,
    })

    function clickEvent(speciesId) {
      nowSelectTrainProject.value.id = speciesId.id;
      nowSelectTrainProject.value.name = speciesId.name;
      showEdit.value = true;
    }

    function editTrainProject() {
      if (nowSelectTrainProject.value.id === "" || nowSelectTrainProject.value.id === undefined) {
        Notify({type: "danger", message: "作业类别未找到,请重新编辑"});
        return;
      }

      if (nowSelectTrainProject.value.name === "" || nowSelectTrainProject.value.name === undefined) {
        Notify({type: "danger", message: "作业类别名称不可为空"});
        return;
      }

      axios
          .post(
              "/api/addTrainInformation/editTrainProject/" +
              nowSelectTrainProject.value.id +
              "/name/" +
              nowSelectTrainProject.value.name
          )
          .then(res => {
            console.log(res.data);
            getAllSpeciesId();
          });
    }

    function deleteTrainProject() {
      if (nowSelectTrainProject.value.id === "" || nowSelectTrainProject.value.id === undefined) {
        Notify({type: "danger", message: "作业类别未找到,请重新编辑"});
        return;
      }
      Dialog.confirm({
        title: "删除警告",
        message: "是否确认删除【" + nowSelectTrainProject.value.name + "】",
      }).then(() => {
        axios
            .post(
                "/api/addTrainInformation/editTrainProject/" +
                nowSelectTrainProject.value.id
            )
            .then(res => {
              console.log(res.data);
              showEdit.value = false
              nowSelectTrainProject.value.id = undefined
              nowSelectTrainProject.value.name = undefined
              getAllSpeciesId();
            });
      }).catch(() => {
        // on cancel
      });
    }


    onMounted(() => {
      getAllSpeciesId();
    });

    return {
      onClickLeft,
      onClickRight,
      router,
      ...toRefs(listDemo),
      addSpeciesId,
      show,
      ProjectName,
      showEdit,
      nowSelectTrainProject,
      clickEvent,
      editTrainProject,
      deleteTrainProject
    };
  }
};
</script>
